import { memo, useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { TopbarButton } from 'app/views/layout/components/layoutContainer/components/topBar/components/button/topbarButton';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent/commandKeybindingsTooltipContent';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButtonOld } from '../topbarButtonOld';

export const SmsTopbarButton = memo(function SmsTopbarButton(): JSX.Element {
  const flags = useFeatureFlag(['new-topbar']);
  const dispatch = useAppDispatch();

  const openCompose = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:composeSms',
        },
      }),
    );
  }, [dispatch]);

  const label = 'New SMS';

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="conversation:composeNewSms">
      {label}
    </CommandKeybindingsTooltipContent>
  );

  return flags.newTopbar ? (
    <TopbarButton
      icon="sms"
      label={label}
      tooltip={tooltip}
      onClick={openCompose}
    />
  ) : (
    <TopbarButtonOld
      onClick={() => openCompose()}
      icon="sms"
      tooltip={tooltip}
    />
  );
});
